import React, { Component } from 'react'
import { PaginateResponse } from '../services/api.service'
import ResultLimiter from './ResultLimiter'
import TableHorizontal, { TableHorizontalProps } from './TableHorizontal'
import SearchPicker from './SearchPicker'
import Paginator from './Paginator'
import { i18n } from '../i18n/i18n'

export interface DataTableData<Data = {}>
  extends
    Pick<TableHorizontalProps<Data>, 'data'>,
    Omit<PaginateResponse<Data>, 'data'> {}

interface DataTableProps extends DataTableData, TableHorizontalProps {
  limit: string
  search: string
  selectedIds?: number[]
  onLimtChange: (limit: string) => void
  onSearch: (term: string) => void
  onPaginate: (page: number) => void
  onSelect?: (ids: number[]) => void
}

interface DataTableState {
  term: string
}

export default class DataTable
  extends Component<DataTableProps, DataTableState> {
  constructor (props: DataTableProps) {
    super(props)
    this.state = {
      term: ''
    }
    this.handleSearchChange = this.handleSearchChange.bind(this)
    this.handleSearch = this.handleSearch.bind(this)
  }

  get status () {
    const { from, to, total } = this.props
    if (!from || !to) return null
    return `${i18n("ShowingX")} + ${from} ${i18n("toX")} ${to} ${i18n("ofX")} ${total} ${i18n("results")}`
  }

  handleSearchChange (name: string, value: string) {
    this.setState({ term: value })
  }

  handleSearch (name: string, term: string) {
    this.props.onSearch(term)
  }

  replaceStateTermWithProps () {
    this.setState({ term: this.props.search })
  }

  componentDidUpdate (props: DataTableProps) {
    if (this.props.search !== props.search) this.replaceStateTermWithProps()
  }

  componentDidMount () {
    this.replaceStateTermWithProps()
  }

  render () {
    return (
      <div className="block">
        <div className="flex flex-col md:flex-row md:justify-between">
          <ResultLimiter value={this.props.limit} onChange={this.props.onLimtChange} />
          <SearchPicker
            name="term"
            value={this.state.term}
            onChange={this.handleSearchChange}
            onSearch={this.handleSearch} />
        </div>
        <TableHorizontal
          headers={this.props.headers}
          data={this.props.data}
          onActionClick={this.props.onActionClick}
          onEditableChange={this.props.onEditableChange}
          onSelect={this.props.onSelect}
          selectedIds={this.props.selectedIds} />
        <div className="flex flex-col lg:flex-row lg:justify-between lg:items-end">
          <p className="text-secondary text-xs mb-1">
            {this.status}
          </p>
          <Paginator
            active={this.props.currentPage}
            total={this.props.lastPage}
            onPaginate={this.props.onPaginate} />
        </div>
      </div>
    )
  }
}
